import { Component, ViewChild } from '@angular/core';
import { MmitaAssetService } from '../../_services/mmitaAsset.service'
import { ModalService } from '../../_services/modal.service';
import { CategoryService } from 'src/app/_services/category.service';
import { AppEvent, Global } from 'src/app/_services/global.service';
import { ToastrService } from 'ngx-toastr';
import { AbilityService } from 'src/app/_services/ability.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SketchfebComponent } from './sketchfeb/sketchfeb.component';
import { InfiniteGridComponent } from 'src/app/ui-library/component/infinite-grid/infinite-grid.component';
import { SearchFieldType } from 'src/app/common/constants';
import { SearchFormComponent } from 'src/app/ui-library/search-form/search-form.component';
import { Observable, forkJoin } from 'rxjs';
import { AssetAbilityTemplate } from './ant-asset-item/asset-item.constant';
import { FormControl, FormGroup } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AntAssetItemComponent } from './ant-asset-item/ant-asset-item.component';
import { GlbGeneratorImageComponent } from './glb-generator-image/glb-generator-image.component';
import { GlbGeneratorTextComponent } from './glb-generator-text/glb-generator-text.component';
import { AttachEventCategoryComponent } from './attach-event-category/attach-event-category.component';
import { VirtualMallService } from 'src/app/_services/virtual-mall.service';
import { DeleteCheckDialogComponent } from './delete-check-dialog/delete-check-dialog.component';
import { VoiceService } from 'src/app/_services/voice.service';
@Component({
  selector: 'app-asset',
  templateUrl: './mmitaAsset.component.html',
  styleUrls: ['./mmitaAsset.component.scss'],
})
export class MmitaAssetComponent extends InfiniteGridComponent {
  @ViewChild('SearchForm', { static: false }) SearchForm!: SearchFormComponent
  searchSection: Array<any> = []
  abilityList: Array<any> = [];
  initialCategory: string = '';
  rendered: boolean = false;
  categoryList: Array<any> = []
  source: any = {}
  constructor(
    private assetService: MmitaAssetService,
    private modalService: ModalService,
    private categoryService: CategoryService,
    public global: Global,
    private toastr: ToastrService,
    private abilityService: AbilityService,
    private route: ActivatedRoute,
    private ngbModal: NgbModal,
    private router: Router,
    private nzModalService: NzModalService,
    private virtualMallService: VirtualMallService,
    private voiceService: VoiceService
  ) {
    super(global);
    this.eventSubscription = this.global.appEvent.subscribe((event: AppEvent) => {
      const { msg, para } = event;
      switch (msg) {
        case 'reload.asset':
          this.loadData()
          break;
      }
    });
    this.initialCategory = this.route.snapshot.paramMap.get('categoryId') || '';
  }
  setColumnDefs() {
    this.columnDefs = [
      { headerCheckboxSelection: true, checkboxSelection: true, maxWidth: 40, sortable: false },
      { headerName: 'ID', field: 'id', },
      {
        headerName: 'Thumbnail', field: 'iconUrl',
        cellClass: 'img-cell', minWidth: 100,
        cellRenderer: (params: any) => {
          if (!params.data) return 'not loaded yet';
          return ` <img height="49" src="${params.value}?m=${Math.random()}" alt="without thumbnail"/>`;
        },
      },
      { headerName: 'Name', field: 'name' },
      { headerName: 'Type', field: 'assetType' },
      { headerName: 'Category', field: 'category.multilingualNames.en-US', sortable: false },
      { headerName: 'Status', field: 'assetStatus' },
      {
        headerName: 'File Size', field: 'file.size', valueFormatter: (params: any) => {
          return params.value ? `${(params.value / (1024 * 1024)).toFixed(2)} M` : '-'
        }
      },
      {
        headerName: 'File Size(Android)', field: 'androidFile.size', valueFormatter: (params: any) => {
          return params.value ? `${(params.value / (1024 * 1024)).toFixed(2)} M` : '-'
        }
      },
      {
        headerName: 'File Size(Vision Pro)', field: 'visionOSFile.size', valueFormatter: (params: any) => {
          return params.value ? `${(params.value / (1024 * 1024)).toFixed(2)} M` : '-'
        }
      },
      { headerName: 'Business Type', field: 'businessType' },
      {
        headerName: 'Ability', field: 'abilitiyIds',
        cellRenderer: (params: any) => {
          if (!params.data) return 'not loaded yet';
          let abilityHtml = '';
          const abiListLength = params.value.length;
          const abNameArray = this.mapAbilityName(params.value);
          abNameArray.forEach((abi, index) => {
            abilityHtml += `<span>${abi} ${index < abiListLength - 1 ? ',' : ''} </span>`
          })
          return abilityHtml;
        }
      },
      { headerName: 'Category ID', field: 'category.id', sortable: false },
      { headerName: 'Unlock Token Amount', field: 'numberOfTokensUnlocked', sortable: true },
      { headerName: 'Scale in Map', field: 'scaleInMap', sortable: true },
      { headerName: 'Downloads', field: 'numberOfDownloads', sortable: true },
      { headerName: 'Favourites', field: 'numberOfFavourites', sortable: true },
      { headerName: 'Views', field: 'numberOfViews', sortable: true },
      { headerName: 'Shares', field: 'numberOfShares', sortable: true },
      {
        headerName: 'Action',
        sortable: false,
        pinned: 'right',
        minWidth: 200,
        cellRenderer: (params: any) => {
          if (!params.data) return 'not loaded yet';
          return `  ${params.data.businessType === 'GameInMarket' ? `<i class="fas fa-fw fa-arrow-right" id="navigate" style="margin-right:3px; cursor: pointer;"></i>` : ``}
                    ${this.robotIcon(params?.data)}
                    <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-edit text-primary" id="editDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-copy text-primary" id="copyDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-bookmark text-secondary" id="attach" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-trash grid-btn-icon text-danger" id="deleteAsset" style="margin-right:3px; cursor: pointer;"></i>`;
        },
        onCellClicked: (params: any) => {
          switch (params.event.target.id) {
            case 'moreDetail':
              this.modalService.showDetail(params.data, 'Asset Detail')
              break;
            case 'editDetail':
              this.showItem(params?.data)
              break;
            case 'copyDetail':
              this.showItem(params?.data, true)
              break;
            case 'deleteAsset':
              this.modalService.createNzDeleteModal(() => this.delete.call(this, params?.data?.id))
              break;
            case 'navigate':
              if (!params.data.gameInfo) {
                this.toastr.info('Did not link game info')
                return
              }
              this.router.navigateByUrl(`/product/${params.data.gameInfo.developerId}`)
              break;
            case 'defaultAiBuddy':
              this.setDefaultAiBuddy(params?.data?.id, params?.data?.name)
              break
            case 'attach':
              this.showAttachEventCategoryDialog(params?.data?.id)
              break
          }
        },
      },
    ];
  }

  private robotIcon(data: any) {
    if (data.businessType !== 'AiBuddy') {
      return ''
    } else if (data.isDefaultAiBuddy) {
      return `<i class="fas fa-fw fa-house-user text-success" style="margin-right:3px; cursor: not-allowed; color: gray"></i>`
    } else {
      return `<i class="fas fa-fw fa-house-user text-secondary" id="defaultAiBuddy" style="margin-right:3px; cursor: pointer;"></i>`
    }
  }

  private setDefaultAiBuddy(id: string, name: string) {
    this.assetService.setDefaultAiBuddy(id).subscribe(() => {
      this.loadData()
      this.toastr.success(`Set ${name} as default AI buddy`)
    })
  }

  loadData() {
    this.gridApi.deselectAll();
    this.gridApi.purgeInfiniteCache();
  }


  ngOnInit() {
    this.setColumnDefs();
  }

  ngAfterViewInit() {
    this.setDatasource((prop: any) => this.assetService.getAll(prop))
    this.getSource().subscribe(source => {
      this.source = source
      this.searchSection = [
        { name: 'Id', key: 'Id' },
        { name: 'Category Name', key: 'CategoryId', type: SearchFieldType.Selector, options: this.categoryList },
        { name: 'Asset Type', key: 'AssetType', type: SearchFieldType.Selector, options: this.global.section?.AssetTypeSelections },
        { name: 'Business Type', key: 'BusinessType', type: SearchFieldType.Selector, options: this.global.section?.AssetBusinessTypeSelections },
        { name: 'Asset Status', key: 'AssetStatus', type: SearchFieldType.Selector, options: ['Active', 'Inactive'] },
        { name: 'Category Type', key: 'AssetCategoryType', type: SearchFieldType.Selector, options: this.global.section?.AssetCategoryTypeSelections },
        { name: 'Category Option', key: 'AssetCategoryOption', type: SearchFieldType.Selector, options: this.global.section?.AssetCategoryOptionsSelections },
        { name: 'File Format', key: 'FileFormat', type: SearchFieldType.Selector, options: this.global.section?.FileFormatSelections },
        { name: 'Name', key: 'Name_Contains', type: SearchFieldType.Text },
      ]
      this.rendered = true
      if (this.initialCategory) {
        setTimeout(() => {
          this.SearchForm.setFormCtrl('CategoryId', this.initialCategory)
        }, 400)
      }
    })
  }


  deleteBatchAssets() {
    const deleteAssets = this.gridApi.getSelectedRows().map((item: any) => {
      return item.id
    });
    if (deleteAssets.length < 1) {
      this.toastr.info('Please select assets', 'Info')
      return;
    } else {
      const msg = `Are you sure you want to delete ${deleteAssets.length > 1 ? `${deleteAssets.length} records` : `${deleteAssets.length} record`}`
      this.modalService.createNzDeleteModal(() => {
        this.assetService.batchDelete({ ids: deleteAssets }).subscribe(res => {
          this.loadData()
          this.toastr.success('Data Deleted Successfully...!', 'Success');
        });
      }, msg)
    }
  }

  updateBatchAssets() {
    const updateAssets = this.gridApi.getSelectedRows().filter((row: any) => {
      return row.assetType === 'Model3d'
    }).map((item: any) => {
      return item.id;
    });
    if (updateAssets.length < 1) {
      this.toastr.info('Please select assets', 'Only Supports Model3d Asset')
      return;
    } else {
      const formGroup = new FormGroup({
        abilityIds: new FormControl([])
      })
      this.modalService.createNzModal(() => this.updateAbility.call(this, updateAssets, formGroup), formGroup, AssetAbilityTemplate(this.abilityList))
    }
  }

  updateAbility(updateAssets: Array<string>, formGroup: FormGroup) {
    return new Observable(sub => {
      this.assetService.batchUpdateAbility({ assetIds: updateAssets, ...formGroup.value }).subscribe(res => {
        this.loadData()
        this.toastr.success(`Update Successfully...!`, 'Success');
        sub.next()
        sub.complete()
      })
    })
  }

  mapAbilityName(idArray: Array<string>) {
    return idArray.map(item => {
      const mapAb = this.abilityList.find(ab => ab.id === item)
      return mapAb ? mapAb.multilingualNames?.['en-US'] : null
    })
  }


  getAccessToken() {
    this.ngbModal.open(SketchfebComponent, { size: 'lg', centered: true });
  }

  delete(itemId: string) {
    this.assetService.predelete([itemId]).subscribe(
      (response: any) => {
        const hasData = this.checkHasRelatedData(response);

        if (hasData) {
          // Show delete check dialog
          this.showDeleteCheckDialog(response, itemId);
        } else {
          // No related data, proceed with delete
          this.proceedDelete(itemId);
        }
      },
      (error) => {
        this.toastr.error('Failed to check asset dependencies', 'Error');
      }
    );
  }

  private checkHasRelatedData(data: any): boolean {
    return (
      (data?.mmitaRewardIds && data.mmitaRewardIds.length > 0) ||
      (data?.campaignWaveIds && data.campaignWaveIds.length > 0) ||
      (data?.streamEventIds && data.streamEventIds.length > 0) ||
      (data?.arIds && data.arIds.length > 0) ||
      (data?.stageIds && data.stageIds.length > 0)
    );
  }

  private showDeleteCheckDialog(deleteCheckData: any, itemId: string) {
    this.nzModalService.create({
      nzContent: DeleteCheckDialogComponent,
      nzWidth: '700px',
      nzTitle: 'Delete Check - Associated Records Found',
      nzFooter: null,
      nzComponentParams: {
        deleteCheckData: deleteCheckData,
        onConfirmDelete: () => this.proceedDelete(itemId)
      },
      nzBodyStyle: {
        'max-height': '70vh',
        'overflow-y': 'auto',
      },
      nzWrapClassName: 'delete-check-modal'
    });
  }

  private proceedDelete(itemId: string) {
    this.assetService.delete(itemId).subscribe(
      (data) => {
        this.loadData();
        this.toastr.success('Data Deleted Successfully...!', 'Success');
      },
      (error) => {
        this.toastr.error('Failed to delete asset', 'Error');
      }
    );
  }

  showItem(orgData?: any, copyMode?: boolean, isBatch?: boolean) {
    this.nzModalService.create({
      nzContent: AntAssetItemComponent,
      nzWidth: '700px',
      nzFooter: null,
      nzTitle: 'Set Asset',
      nzOnOk: () => {
        this.toastr.success('Saved Successfully...!', 'Success');
        this.loadData()
      },
      nzComponentParams: {
        source: this.source,
        data: orgData,
        copyMode: copyMode,
        isBatch: isBatch
      },
      nzBodyStyle: {
        'max-height': '70vh',
        'overflow-y': 'auto',
      },
    })
  }



  getSource() {
    return new Observable(subscriber => {
      forkJoin({
        categoryList: this.categoryService.getAssetCategory(),
        abilityList: this.abilityService.getAll(),
        virtualMall: this.virtualMallService.getAll(),
        voiceList: this.voiceService.getAll()

      }).subscribe(res => {
        this.categoryList = res.categoryList.data.map(item => {
          return { ...item, name: item.multilingualNames?.['en-US'] }
        })
        this.abilityList = res.abilityList.map(item => {
          return { ...item, name: item.multilingualNames?.['en-US'] }
        });
        const source = {
          abilityList: this.abilityList,
          assetTypeSelections: this.global.section.AssetTypeSelections,
          assetBusinessTypeSelections: this.global.section.AssetBusinessTypeSelections,
          categoryFilterByType: this.mapCategorySource(this.categoryList),
          virtualMall: res.virtualMall.data,
          voiceList: res.voiceList.data.map(item => {
            return {
              name: item.speakerName,
              id: item.azureSpeakerProfileId
            }
          })
        }
        subscriber.next(source)
        subscriber.complete()
      })
    })
  }

  private mapCategorySource(categoryList: Array<any>) {
    const catForAsset = {} as any
    this.global.section.AssetTypeSelections.forEach((item: any) => {
      catForAsset[item] = []
    })
    categoryList.forEach(cat => {
      this.global.section.AssetTypeSelections.forEach((item: any) => {
        // End-users allow to upload: maxNumberOfUploadsForCustomer>0
        // Admin allow to upload: maxNumberOfUploadsForCustomer=0
        if (item === cat.assetType && cat.maxNumberOfUploadsForCustomer <= 0) {
          catForAsset[item].push(cat)
        }
      })
    })
    return catForAsset
  }

  open3DGenerator(type: 'Image' | 'Text') {
    const contect = (type === 'Image' ? GlbGeneratorImageComponent : GlbGeneratorTextComponent) as any
    const modalRef = this.nzModalService.create({
      nzContent: contect,
      nzWidth: '700px',
      nzFooter: null,
      nzTitle: `Create Asset by ${type}`,
      nzOnCancel: () => {
        this.showConfirmDialog(() => {
          modalRef.close();
        });
        return false; // Prevent the modal from closing immediately
      }
    })

    modalRef.afterClose.subscribe((data) => {
      if (data) {
        this.showItem(data, true, false)
      } else {
        console.log('模态框被取消');
      }
    });
  }

  showConfirmDialog(onOk: () => void) {
    this.nzModalService.confirm({
      nzTitle: 'Confirm',
      nzContent: 'Are you sure you want to leave?',
      nzOkText: 'OK',
      nzCancelText: 'Cancel',
      nzOnOk: () => {
        onOk();
      },
      nzOnCancel: () => {
        // Do nothing or handle cancel action if needed
      }
    });
  }

  showAttachEventCategoryDialog(id: string) {
    const modal = this.nzModalService.create({
      nzContent: AttachEventCategoryComponent,
      nzFooter: null,
      nzTitle: 'Attach Event Category',
      nzComponentParams: {
        id: id,
      },
    });
  }


}
